const API_BASE = window.location.origin + '/api/asi/webhooks';

export async function sendPrompt(prompt) {
  const res = await fetch(`${API_BASE}/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ prompt }),
  });

  if (!res.ok) throw new Error('Failed to send prompt');
  return res.json();
}
